// extracted by mini-css-extract-plugin
export default {"form":"fVFEBl_x","mobile":"mobile","row":"n3Vyyqzx","field":"qsBeaPS7","phoneConfirm":"C8jJxofO","footer":"o3fxpiTD"};